/* eslint-disable no-restricted-exports */
import ar from "@/i18n/locales/ar.json";
import de from "@/i18n/locales/de.json";
import en from "@/i18n/locales/en.json";
import es from "@/i18n/locales/es.json";
import fr from "@/i18n/locales/fr.json";
import it from "@/i18n/locales/it.json";
import ja from "@/i18n/locales/ja.json";
import ko from "@/i18n/locales/ko.json";
import nl from "@/i18n/locales/nl.json";
import pl from "@/i18n/locales/pl.json";
import sv from "@/i18n/locales/sv.json";
import tr from "@/i18n/locales/tr.json";

const langs = [
    { code: "de", file: "de.json", iso: "de-DE" },
    { code: "en", file: "en.json", iso: "ed-EN" },
    { code: "fr", file: "fr.json", iso: "fr-FR" },
    { code: "nl", file: "nl.json", iso: "nl-NL" },
    { code: "ar", file: "ar.json", iso: "ar-AR" },
    { code: "es", file: "es.json", iso: "es-ES" },
    { code: "it", file: "it.json", iso: "it-IT" },
    { code: "ja", file: "ja.json", iso: "ja-JA" },
    { code: "ko", file: "ko.json", iso: "ko-KO" },
    { code: "pl", file: "pl.json", iso: "pl-PL" },
    { code: "sv", file: "sv.json", iso: "sv-SV" },
    { code: "tr", file: "tr.json", iso: "tr-TR" },
];

export default defineI18nConfig(() => ({
    availableLocales: langs,
    fallbackLocale: "de",
    globalInjection: true,
    legacy: false,
    locale: "de",
    locales: langs,
    messages: {
        ar,
        de,
        en,
        es,
        fr,
        it,
        ja,
        ko,
        nl,
        pl,
        sv,
        tr,
    },
    mode: "composition",
    parsePages: false,
    precompile: {
        strictMessage: false,
    },
    strictMessage: false,
    types: "composition",
    vueI18nLoader: false,
}));
